import React from 'react';
import { TableRow } from '@mui/material';
import modalities from '@core/constants/modalities';
import StatisticsCell from '../../StatisticsCell';
import UsersCell from '../../UserCell';

export type Modalities = Record<string, number>;

export interface Item {
  modalities: Modalities;
  entityName: string;
  entityId: string;
  userProfilePhoto?: string;
}

const ReferrerStatisticRow = ({ entity }: { entity: Item }) => {
  const totalStudies = Object.keys(entity.modalities)
    .filter((modality) => modality !== 'NDM')
    .reduce((prev, curr) => prev + entity.modalities[curr], 0);

  return (
    <TableRow key={entity.entityId}>
      <UsersCell userFullName={entity.entityName} profilePhoto={entity.userProfilePhoto || ''} />
      <StatisticsCell title={`${totalStudies || 0} Estudios`} />
      {modalities.map((modality) => (
        <StatisticsCell
          key={entity.entityId + modality}
          title={`${entity.modalities[modality] || 0} Estudios`}
        />
      ))}
    </TableRow>
  );
};

export default ReferrerStatisticRow;
